import { Typography } from "@mui/material";

import ConfirmationModal, {
  ConfirmationModalProps,
} from "@rui/ConfirmationModal";

type ProcessingUploadsModalProps = Pick<
  ConfirmationModalProps,
  "open" | "onClose"
>;

const ProcessingUploadsModal = ({
  open,
  onClose,
}: ProcessingUploadsModalProps) => {
  return (
    <ConfirmationModal
      title="Creating your meeting reports"
      open={open}
      cancelProps={{ show: false }}
      confirmProps={{
        label: "Got it",
      }}
      onClose={onClose}
      onConfirm={onClose}
      size="md"
    >
      <Typography variant="bodyPrimaryReg" sx={{ color: "shades.neutral.600" }}>
        Your video uploads are processing, which can take up to 24 hours. We’ll
        notify you by email when these uploads are processed and ready!
      </Typography>
    </ConfirmationModal>
  );
};

export default ProcessingUploadsModal;
